/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import { createLogic } from 'redux-logic';

import { addToast } from 'state/toast/ToastActions';
import { analyticsActionSuccess } from 'state/analytics/AnalyticsActions';
import {
  RECEIVED_CHALLENGE_DEPOSIT_VERIFICATION,
  RECEIVED_REINITIATE_CHALLENGE_DEPOSITS
} from '../linkedBankAccounts/LinkedBankAccountsActions';

const ChallengeDepositsLogic = createLogic({
  type: [
    RECEIVED_REINITIATE_CHALLENGE_DEPOSITS,
    RECEIVED_CHALLENGE_DEPOSIT_VERIFICATION
  ],

  process({ action }, dispatch, done) {
    const { requestResult } = action;

    if (requestResult) {
      // dispatch user message
      dispatch(addToast(true, 'Challenge Deposits processing was successful'));

      // dispatch analytics message
      dispatch(analyticsActionSuccess('ProfPref', 'ChallengeDeposits'));
    }

    done();
  }
});

export default ChallengeDepositsLogic;
